import { IComponentController, IFormController, IScope } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItem } from '../../../../../core/services/menu/menu-item.service';
import { IProfil } from '../../../../../core/resources/profil.resource';
import { IStateParamsService } from 'angular-ui-router';
import { IOperateurService } from '../../../../../core/services/operateur.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageAl2005 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    simulerMenus: Array<IMenuItem>;
    detMultiOccurrenceOptions: IMultiOccurrenceOptions;
    detMultiOccurrence: IMultiOccurrence;
    dsiMultiOccurrence: IMultiOccurrence;
    ppacleint: any;
    formCtrl: IFormController;
}

/* @ngInject */
export default function Al2005Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemAction: IMenuItemActionClass,
    Operateur: IOperateurService,
    profil: IProfil,
    MenuItemForage: IMenuItemForageClass, 
    MenuItemEcran: IMenuItemEcranClass,
    al2010Route: IRoute,
    $scope: IScope,
    Pagination: IPaginationClass,
    $stateParams: IStateParamsService
) {
    const vm: IPageAl2005 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        fonctions: {
            suiviModification: false,
            boutonEnregistrerHaut: false,
            exportation: false,
            boutonDupliquer: false
        }
    };
    vm.ppacleint = null;    

    vm.simulerMenus = [
        new MenuItemAction(
            'LBL_BTN_SIMULER',
            'BOUSIMULER',
            () => ({
                id: $stateParams.dalcleint,
                ppacleint: vm.ppacleint,
                demcleint: $stateParams.demcleint,
                usrcleint: profil.preferences.usrcleint
            }),
            {
                iconButton: false,
                icon: 'sync',
                formulaireConfirmationAction: {
                    lblTitre: "LBL_BTN_TMP",
                    lblConfirm: "G_LBL_LBL_BTN_TMP",
                    largeurFormulaire: 50,
                    formulaire: new Formulaire([
                        new FormulaireItem('ppacleint', {
                            largeur: 100,
                            resourceParams: () => ({ dalcleint: $stateParams.id, demcleint: $stateParams.demcleint }),
                            onValueChange: (data: any) => {
                                if (data.ppacleint) {
                                    vm.ppacleint = Object.assign({ ppacleint: data.ppacleint }, vm.formCtrl.pap.ppacleint.$$scope.vm.suggestion);
                                }
                            }
                        })
                    ])
                },
                successAction: () => { vm.monoOccurrence.fetchData() }
            }
        ),
        new MenuItemForage("", al2010Route.NAME, () => ({ecran: '01-2'}),
        {            
            iconButton: true,
            icon: (data: any) => data.inc_nbr > 0 ? "warning" : ' ',
            hidden: (data: any) => data.inc_nbr > 0 ? false : true,
            compteur: (data: any) => data.inc_nbr > 0 ? data.inc_nbr : undefined
        }
    )
    ];
    vm.formulaireDal = new Formulaire('LBL_BLC_SIM', [
        new FormulaireItem('demcleint', { default: $stateParams.demcleint, largeur: 45 }),
        new FormulaireItem('lemcleint', { default: $stateParams.lemcleint, largeur: 55 }),
        new FormulaireItem('tdlcleint', { default: $stateParams.tdlcleint, largeur: 45 }),
        new FormulaireItem('dalnumdoc', { default: $stateParams.dalnumdoc, largeur: 55 }),
        new FormulaireItem('dalcleint', { default: $stateParams.id }),
        new FormulaireItem('t_ppacod', { largeur: 50, hidden: (data: any) => data.ppacleintt || !data.t_ppacod}),
        new FormulaireItem('ppacleintt',
            {
                largeur: 33,
                readonly: (data: any) => data.ppacleintt,
                hidden: (data: any) => !data.ppacleintt
            }),
        { largeurDefaut: 50 }
    ]);

    // Bloc Résultats
    vm.detMultiOccurrenceOptions = {
        etatsPredefinis: [
            {
                nom: 'Sommaire',
                filtres: [
                    {
                        colonne: 'axe',
                        operateur: Operateur.EGALE,
                        valeur: 'SOM'
                    }
                ],
                colonnesVisibles: ['tagcod', 'tagdscabr', 'alzqtecal', 'alzmntcal']
            },
            {
                nom: 'Détaillé',
                filtres: [
                    {
                        colonne: 'axe',
                        operateur: Operateur.EGALE,
                        valeur: 'DET'
                    }
                ],
                colonnesVisibles: [
                    'alzdatdeb',
                    'alzdatfin',
                    'tagcod',
                    'tagdscabr',
                    'alzqtecal',
                    'alztaucal',
                    'alzmntcal',
                    'aftcod',
                    'lemcod',
                    'dernumdoc',
                    'drpnumdoc',
                    'vaesysprvfed'
                ]
            }
        ],
        bloc: 'det',
        pagination: new Pagination({
            nombreElementPage: 50,
            nbElementsPossibles: [50, 100, 150]
        }),
        colonnesVisibles: [
            { nom: 'alzdatdeb', largeur: 100 },
            { nom: 'alzdatfin', largeur: 100 },
            { nom: 'tagcod', largeur: 100 },
            { nom: 'tagdscabr', largeur: 310 },
            { nom: 'alzqtecal', largeur: 100 },
            { nom: 'alztaucal', largeur: 184 },
            { nom: 'alzmntcal', largeur: 100 },
            { nom: 'aftcod', largeur: 184 },
            { nom: 'lemcod', largeur: 184 },
            { nom: 'dernumdoc', largeur: 184 },
            { nom: 'drpnumdoc', largeur: 184 },
            { nom: 'vaesysprvfed', largeur: 184 }
        ],
        colonnesCachees: ['tagcleint', 'dalcleint', 'axe']
    };
}
